import Modal from './Modal';
import ResponsiveModal from './ResponsiveModal';
import modalStyles from './modal.module.scss';
import responsiveModalStyles from './responsiveModal.module.scss';

export {
  Modal,
  modalStyles,
  ResponsiveModal,
  responsiveModalStyles,
};

export default Modal;
